(() => {
  const dialog = document.getElementById("video-modal");
  if (!dialog) return;

  const playerHolder = dialog.querySelector("[data-video-player-holder]");
  let player = null;
  let pendingInit = null;
  let apiLoading = false;

  window.onYouTubeIframeAPIReady = () => {
    if (pendingInit) {
      createPlayer(pendingInit.videoId, pendingInit.startTime, pendingInit.autoplay);
      pendingInit = null;
    }
  };

  function loadYTApi() {
    if (apiLoading || document.getElementById("yt-iframe-api")) return;
    apiLoading = true;
    const script = document.createElement("script");
    script.id = "yt-iframe-api";
    script.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(script);
  }

  function createPlayer(videoId, startTime, autoplay) {
    playerHolder.innerHTML = "";
    const el = document.createElement("div");
    playerHolder.appendChild(el);
    player = new YT.Player(el, {
      videoId,
      width: "100%",
      height: "100%",
      playerVars: { start: startTime, playsinline: 1, rel: 0 },
      events: {
        onReady(e) {
          if (autoplay) e.target.playVideo();
        }
      }
    });
  }

  function destroyPlayer() {
    player?.destroy();
    player = null;
    pendingInit = null;
    playerHolder.innerHTML = "";
  }

  function openModal(btn) {
    const video = btn.dataset.video;
    if (!video) return;

    const videoId = video.includes("embed/")
      ? video.split("embed/").pop().split("?")[0]
      : video;
    const startTime = parseInt(btn.dataset.videoStartTime, 10) || 0;
    const autoplay = btn.dataset.autoplay === "true";

    loadYTApi();

    if (window.YT?.Player) {
      createPlayer(videoId, startTime, autoplay);
    } else {
      pendingInit = { videoId, startTime, autoplay };
    }

    dialog.showModal();
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    dialog.close();
    document.body.style.overflow = "";
  }

  // Open on any [data-video] click
  document.addEventListener("click", e => {
    const btn = e.target.closest("[data-video]");
    if (!btn) return;
    openModal(btn);
  });

  // Close on backdrop click (click lands on <dialog> itself, not its children)
  dialog.addEventListener("click", e => {
    if (e.target === dialog) closeModal();
  });

  // Close button
  dialog.addEventListener("click", e => {
    if (e.target.closest(".video-modal__close")) closeModal();
  });

  // Cleanup when dialog closes (Escape key or closeModal())
  // Focus return to opener is handled natively by <dialog>
  dialog.addEventListener("close", destroyPlayer);
})();
